import { render } from "./MoreRecomm.vue?vue&type=template&id=297fd59a&scoped=true&ts=true"
import script from "./MoreRecomm.vue?vue&type=script&setup=true&lang=ts"
export * from "./MoreRecomm.vue?vue&type=script&setup=true&lang=ts"

import "./MoreRecomm.vue?vue&type=style&index=0&id=297fd59a&lang=scss&scoped=true"

import exportComponent from "/Users/luoke/Desktop/新开发代码_git/h5-jalalive/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-297fd59a"],['__file',"src/views/home/MoreRecomm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "297fd59a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('297fd59a', __exports__)) {
    console.log('reload')
    api.reload('297fd59a', __exports__)
  }
  
  module.hot.accept("./MoreRecomm.vue?vue&type=template&id=297fd59a&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('297fd59a', render)
  })

}


export default __exports__